var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.id,staticClass:"flex-column mx-3 mb-3 justify-content-between service",class:{
    serviceHired: _vm.hired,
    serviceNotHired: !_vm.hired,
    selectedBorder: _vm.border
  },attrs:{"id":_vm.id,"tabindex":"0"}},[_c('div',{staticClass:"align-self-start pl-3 pt-4",staticStyle:{"height":"45%","margin":"0 2px 2px 0"}},[_c('b-img',{attrs:{"height":"30","src":_vm.getServiceIcon}})],1),_c('div',{staticClass:"card-text",attrs:{"title":_vm.name}},[_c('p',[_vm._v(_vm._s(_vm.name))])]),_c('div',{staticClass:"card-text-description"},[_c('p',[_vm._v(_vm._s(_vm.description))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }